import { BodyXs } from "@/domains/design/components/body-xs"
import { ScaleInnerCard300 } from "@/domains/design/components/scale-inner-card-300"
import { SettingsIcon } from "@/domains/icons"

export const SlippageInnerCard200 = ({
  onChangeSlippage,
  slippage,
}: {
  onChangeSlippage: () => void
  slippage: number
}) => {
  return (
    <ScaleInnerCard300 className="flex cursor-pointer items-center gap-1 p-1 px-2" onClick={onChangeSlippage}>
      <BodyXs>Slippage: {slippage.toString()}%</BodyXs>
      <SettingsIcon size={16} className="stroke-1 text-t100" />
    </ScaleInnerCard300>
  )
}
